import dayjs from 'dayjs'
import isEqual from 'lodash/isEqual'

export const processDate = date => dayjs(date, 'MM/DD/YYYY').toISOString()

export const processTime = value => ({
  displayName: value,
  value
})

export const createTimeOptions = (timeBlocks) => timeBlocks.map(({ displayName: label, value }) => ({ label, value }))

export const tomorrowSelected = (currentDate) => {
  const today = dayjs().startOf('day')
  const tomorrow = dayjs(today).add(1, 'd')

  return tomorrow.isSame(currentDate, 'day')
}

export const generateAvailableApptTimesPayload = (times = [], appointmentDateAndSlotsVO = []) => {
  const numberOfNextDayAppointments = String(times.length)
  const nextDayAppointmentOptions = times.map(({ value = '' } = {}) => value.split(' ').join('')).join(', ')
  const numberOfSelectableDates = String(appointmentDateAndSlotsVO
    .filter(({ allAvailableTimes = [], startTime = '' } = {}) => allAvailableTimes.length && startTime !== 'Closed')
    .length)

  return {
    numberOfSelectableDates,
    numberOfNextDayAppointments,
    nextDayAppointmentOptions
  }
}

export const wasProductOrServiceAddedOrRemoved = ({
  services: prevServices = [],
  products: prevProducts = []
}, {
  services = [],
  products = []
}) =>
  prevProducts.length !== products.length
  || !isEqual(
    prevServices.map(({ commerceItemId }) => ({ commerceItemId })),
    services.map(({ commerceItemId }) => ({ commerceItemId }))
  ) || !isEqual(
    prevProducts.map(({ commerceItemId }) => ({ commerceItemId })),
    products.map(({ commerceItemId }) => ({ commerceItemId }))
  )

// This function is used to filter the appointment slots for NTW and secondary supplier from 12pm.
export const filterAppointmentSlotsForPilotStore = (data, currentDate, calendarStartDate = '', skusAddedToCart, isPilotStore) => {
  if (isPilotStore) {
    const startDate = dayjs(calendarStartDate).get('date')
    const bufferTime = skusAddedToCart?.find(({ availableAsOf }) => availableAsOf?.includes(startDate) && availableAsOf.includes('12'))
    if (dayjs(currentDate).format('MM/DD/YYYY') === calendarStartDate && bufferTime) {
      return data.filter(item => item.displayName.includes('pm'))
    }
  }

  return data
}
